export default __webpack_public_path__ + "static/media/level-low.1174222e.svg";